import React from 'react';
import { useTable } from 'react-table';

import {
  Cell,
  Container,
  TBody,
  TD,
  TH,
  THead,
  TR,
  Wrapper,
  Table,
} from './style';

export default ({ headers, data = [], height, id = '' }) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable({
      columns: headers,
      data,
    });

  return (
    <Container>
      <Wrapper height={height}>
        <Table {...getTableProps()} id={id}>
          <THead>
            {headerGroups.map((headerGroup, i) => (
              <TR {...headerGroup.getHeaderGroupProps()} key={`${i + 1}`}>
                {headerGroup.headers.map(
                  (header, ind) =>
                    !header.displayNone && (
                      <TH
                        {...header}
                        key={`${ind + 1}`}
                        {...header.getHeaderProps()}
                        rowSpan={header.rowSpan ? header.rowSpan : 1}
                        style={header.displayNone ? { display: 'none' } : {}}
                      >
                        <Cell {...header}>{header.render('Header')}</Cell>
                      </TH>
                    )
                )}
              </TR>
            ))}
          </THead>
          <TBody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <TR {...row.getRowProps()} key={`${i + 1}`}>
                  {row.cells.map((cell, idx) => {
                    const { column } = cell;
                    return (
                      <TD key={`${idx + 1}`} {...cell.getCellProps()}>
                        <Cell {...column}>{cell.render('Cell')}</Cell>
                      </TD>
                    );
                  })}
                </TR>
              );
            })}
          </TBody>
        </Table>
      </Wrapper>
    </Container>
  );
};
